class FieldsetToggle extends HTMLElement {
  constructor() {
    super();
    this.lastWidth = window.innerWidth;
  }

  connectedCallback() {
    const bubble = this.querySelector('.selection-bubble');
    if (bubble) {
      bubble.style.transition = 'none';
    }
  
    this.positionBubble();
  
    if (bubble) {
      requestAnimationFrame(() => {
        bubble.style.transition = '';
      });
    }
  
    document.addEventListener('variantSelection:priceInfo', (e) => {
      const { regularPrice, salePrice, quantity } = e.detail;
      const discountPriceEl = document.querySelector('[data-savings-calculation]');
      if (!discountPriceEl) return;
      
      if (!salePrice || !regularPrice) {
        discountPriceEl.innerText = ``;
        return;
      }
      
      const parsedQuantity = isNaN(parseInt(quantity)) ? 1 : parseInt(quantity);
      const regularPriceValue = parseFloat(regularPrice.replace('$', ''));
      const salePriceValue = parseFloat(salePrice.replace('$', ''));
      
      if (isNaN(regularPriceValue) || isNaN(salePriceValue) || salePriceValue >= regularPriceValue) {
        discountPriceEl.innerText = ``;
        return;
      }
      
      const percentageOff = ((regularPriceValue - salePriceValue) / regularPriceValue) * 100;
      discountPriceEl.innerText = `${parsedQuantity ? `Buy ${parsedQuantity} ` : ``} Save ${Math.floor(Number(percentageOff))}%`;
    });
  
    this.addEventListener('change', e => {
      this.positionBubble();
    });
  }  
  
  positionBubble() {
    const bubble = this.querySelector('.selection-bubble');
    bubble.style.width = `${this.getSelectedItem().offsetWidth}px`;
    bubble.style.left = `${this.getSelectedItem().getBoundingClientRect().left - this.getBoundingClientRect().left - 2}px`;
  }
  
  getSelectedItem() {
    return this.querySelector('[data-toggle-item]:has(:checked)');
  }
}

customElements.define('fieldset-toggle', FieldsetToggle);